import { CheckCircleFilled } from '@ant-design/icons'
import classNames from 'classnames'

import type { CreatedNomenclatureItem } from '../lib/singularImportResult'
import cn from './NomenclatureCreatedCard.module.scss'

type NomenclatureCreatedCardProps = {
  description: string
  items: CreatedNomenclatureItem[]
  isOrganisationSelected: boolean
}

function NomenclatureCreatedCard({
  description,
  items,
  isOrganisationSelected,
}: NomenclatureCreatedCardProps) {
  return (
    <section
      className={classNames(
        cn.card,
        isOrganisationSelected && cn.accentSelected
      )}
      aria-label="Созданный товар"
    >
      <header className={cn.header}>
        <CheckCircleFilled className={cn.icon} aria-hidden />
        <div>
          <p className={cn.caption}>Номенклатура создана</p>
          <h3 className={cn.title}>{description}</h3>
        </div>
      </header>
      <dl className={cn.items}>
        {items.map((item) => (
          <div key={item.label} className={cn.item}>
            <dt>{item.label}</dt>
            <dd>{item.value}</dd>
          </div>
        ))}
      </dl>
    </section>
  )
}

export default NomenclatureCreatedCard
